import { Component } from "@angular/core";
import { AlertController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { Pledge } from "../../models/interfaces/pledge.model";
import { PrivilegeRole } from "../../models/interfaces/privilegerole.model";
import { PledgeAddPage } from "../../pages/pledge/pledge_add";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-pledge",
  templateUrl: "pledge.html",
})

export class PledgePage {
  public static readonly PLEDGE_ADD_ACCESS = "addPledge";
  public static readonly PLEDGE_VIEW_ACCESS = "viewPledge";
  private page: string = "pledge";
  private upcoming: string = "upcoming";
  private hasAddPledgeAccess: boolean = false;
  private exportViewName = "vw_exprt_pledges_past_12_mths";
  private exportFileName = "PledgePast12Mths";
  private showPaid: boolean = false;
  private showUnpaid: boolean = true;
  private showUpcoming: boolean = false;
  private showWrittenOff: boolean = false;
  private pledge_type: string = "Unpaid";
  private pledge_paid: any;
  private pledge_unpaid: any;
  private pledge_upcoming: any;
  private pledge_writtenoff: any;
  private member$: any;
  private privilegerole$: Observable<PrivilegeRole[]>;
  private styleName: string ="";
  private member: Member;
  private tmpSearchObject_All;
  private tmpSearchObject_Paid;
  private tmpSearchObject_Unpaid;
  private tmpSearchObject_Upcoming;
  private tmpSearchObject_WrittenOff;
  private zippedUpcoming: boolean = true;
  private zippedPaid: boolean = true;
  private zippedUnpaid: boolean = false;
  private zippedWrittenOff: boolean = true;

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController,
    public navParams: NavParams, public alertCtrl: AlertController,
    private db: DbserviceProvider,
  ) {
    console.log("PledgePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    if (this.authService.currentUser) {
      this.hasAddPledgeAccess = this.db.hasAccess(PledgePage.PLEDGE_ADD_ACCESS);
    }
  }

  private onInitPage() {
    console.log("PledgePage onInitPage");

    this.db.dbCol({
      "action": "select", "mapObject": "pledge", "sqlExtended": " where pledge.ps_id in (0,1,2) order by pledge.ps_id, pledge.pl_date desc",
    }).subscribe((pl) => {
      this.tmpSearchObject_All = pl;
      this.tmpSearchObject_Paid = this.pledge_paid = this.tmpSearchObject_All.filter(data => data.ps_name == 'Paid');
      this.tmpSearchObject_Unpaid = this.pledge_unpaid = this.tmpSearchObject_All.filter(data => data.ps_name == 'Unpaid');
      this.tmpSearchObject_WrittenOff = this.pledge_writtenoff = this.tmpSearchObject_All.filter(data => data.ps_name == 'Written Off');
    });

    this.db.dbCol({
      "action": "select", "mapObject": "vw_listbirthdays",
    }).subscribe((pl) => {
      this.tmpSearchObject_Upcoming = this.pledge_upcoming = pl;
    });

  }

  private ionViewWillEnter() {
    console.log("PaymentPage ionViewWillEnter");
    this.onInitPage();
  }

  private ngOnDestroy() {
    console.log("PledgePage ngOnDestroy");
    this.pledge_paid = null;
    this.pledge_unpaid = null;
    this.pledge_upcoming = null;
    this.pledge_writtenoff = null;
  }

  private addPledge() {
    console.log("PledgePage addPledge");
    this.navCtrl.push(PledgeAddPage);
  }

  private search(searchbar, status_type) {
    console.log("PledgePage searchbar");
    let q = searchbar.target.value;

    if (q.trim() === "") {
      if (status_type === "Unpaid") {
        this.pledge_unpaid = this.tmpSearchObject_Unpaid;
      }
      else if (status_type === "WrittenOff") {
        this.pledge_writtenoff = this.tmpSearchObject_WrittenOff;
      }
      else if (status_type === "Upcoming") {
        this.pledge_upcoming = this.tmpSearchObject_Upcoming;
      }
      else {
        this.pledge_paid = this.tmpSearchObject_Paid;
      }
      return;
    }
    if (status_type === "Unpaid") {
      this.pledge_unpaid = this.pledge_unpaid.filter((arrayEl) => arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1,
      );
    }
    else if (status_type === "WrittenOff") {
      this.pledge_writtenoff = this.pledge_writtenoff.filter((arrayEl) => arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1,
      );
    }
    else if (status_type === "Upcoming") {
      this.pledge_upcoming = this.pledge_upcoming.filter((arrayEl) => arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1,
      );

    }
    else {
      this.pledge_paid = this.pledge_paid.filter((arrayEl) => arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1,
      );
    }
  }

  private showConfirm(title: string, message: string): boolean {
    console.log("PledgePage showConfirm");
    let ret = false;
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            ret = true;
          },
          "text": "Yes",
        },
        {
          "handler": () => {
            confirm.dismiss();
            ret = false;
          },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
    return ret;
  }
  private togglePaid() {
    console.log("PledgePage togglePaid");
    if (this.showPaid === true) { this.showPaid = false; } else { this.showPaid = true; this.pledge_type = "Paid"; }
    this.zippedPaid = !this.zippedPaid;
  }
  private toggleWrittenOff() {
    console.log("PledgePage toggleWrittenOff");
    if (this.showWrittenOff === true) { this.showWrittenOff = false; } else { this.showWrittenOff = true; this.pledge_type = "WrittenOff"; }
    this.zippedWrittenOff = !this.zippedWrittenOff;
  }
  private toggleUnpaid() {
    console.log("PledgePage toggleUnpaid");
    if (this.showUnpaid === true) { this.showUnpaid = false; } else { this.showUnpaid = true; this.pledge_type = "Unpaid"; }
    this.zippedUnpaid = !this.zippedUnpaid;
  }
  private toggleUpcoming() {
    console.log("PledgePage toggleUpcoming");
    if (this.showUpcoming === true) { this.showUpcoming = false; } else { this.showUpcoming = true; this.pledge_type = "Upcoming"; }
    this.zippedUpcoming = !this.zippedUpcoming;
  }
}



// WEBPACK FOOTER //
// ./src/pages/pledge/pledge.ts